import React, { useState } from 'react';
import Button from '../ui/Button';
import Input from '../ui/Input';
import { eventsService } from '../../services';

const CreateEventModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    type: 'OTHER',
    startDate: '',
    points: '0'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const eventData = {
        ...formData,
        points: parseInt(formData.points) || 0,
        startDate: new Date(formData.startDate).toISOString(),
      };

      await eventsService.createEvent(eventData);
      onSubmit();
      setFormData({
        name: '',
        description: '',
        type: 'OTHER',
        startDate: '',
        points: '0'
      });
    } catch (err) {
      console.error('Error creating event:', err);
      setError(err.response?.data?.error || 'Erro ao criar evento');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-80">
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl border border-white/10 shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <form onSubmit={handleSubmit} className="p-4 sm:p-6">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
            <h2 className="text-xl sm:text-2xl font-bold text-white">
              ✨ Criar Novo Evento
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 hover:text-white hover:bg-white/10 rounded-full w-8 h-8 flex items-center justify-center transition-colors text-2xl self-end sm:self-auto"
            >
              ×
            </button>
          </div>

          {/* Error */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-400 px-4 py-3 rounded-xl mb-6 flex items-center">
              <span className="mr-2">⚠️</span>
              {error}
            </div>
          )}

          {/* Form Fields */}
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Nome do Evento"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Ex: PVP do Midranda Ressurgido"
                variant="glass"
              />

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">
                  Tipo de Evento
                </label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-slate-700/50 border border-white/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                >
                  <option value="PVP" className="bg-slate-800 text-white">🗡️ PvP</option>
                  <option value="BC" className="bg-slate-800 text-white">🏰 Bless Castle</option>
                  <option value="MEETING" className="bg-slate-800 text-white">👥 Reunião</option>
                  <option value="OTHER" className="bg-slate-800 text-white">🎯 Outro</option>
                </select>
              </div>
            </div>

            <Input
              label="Descrição"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Descreva o evento em detalhes..."
              variant="glass"
              as="textarea"
              rows="3"
            />

            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
              <Input
                label="Data e Hora de Início"
                name="startDate"
                type="datetime-local"
                value={formData.startDate}
                onChange={handleChange}
                required
                variant="glass"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Pontos de Recompensa"
                name="points"
                type="number"
                min="0"
                value={formData.points}
                onChange={handleChange}
                required
                placeholder="Ex: 100"
                variant="glass"
                leftIcon="🏆"
              />
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-3 mt-8">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              loading={loading}
              disabled={loading}
            >
              {loading ? 'Criando...' : 'Criar Evento'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateEventModal;